export default function TestAiGenerator({
    mode,
    value,
    vacancies,
    loading,
    onModeChange,
    onChange,
    onGenerate,
}) {
    return (
        <section className="rounded-2xl border border-indigo-100 bg-gradient-to-br from-indigo-50 to-blue-50 p-6">
            <div className="mb-4 flex items-center gap-2">
                <svg className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                <h3 className="font-bold text-indigo-900">AI-генерация</h3>
            </div>
            <div className="mb-4 flex w-fit rounded-xl border border-indigo-100/50 bg-white/50 p-1">
                <button type="button" onClick={() => onModeChange("manual")} className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${mode === "manual" ? "bg-white text-indigo-900 shadow-sm" : "text-indigo-600 hover:bg-white/50"}`}>Вручную</button>
                <button type="button" onClick={() => onModeChange("ai")} className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${mode === "ai" ? "bg-indigo-600 text-white shadow-sm" : "text-indigo-600 hover:bg-white/50"}`}>Сгенерировать</button>
            </div>
            {mode === "ai" && (
                <div className="space-y-4">
                    <label className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-indigo-900">Тематика теста *</span>
                        <input type="text" value={value.topic} onChange={(event) => onChange({ ...value, topic: event.target.value })} className="w-full rounded-xl border border-indigo-200 bg-white px-4 py-2.5 text-sm outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50" placeholder="Например, Оценка soft skills..." />
                    </label>
                    <label className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-indigo-900">Привязать к вакансии *</span>
                        <select value={value.vacancy_id} onChange={(event) => onChange({ ...value, vacancy_id: event.target.value })} className="w-full cursor-pointer appearance-none rounded-xl border border-indigo-200 bg-white px-4 py-2.5 pr-10 text-sm outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50">
                            <option value="">Выберите вакансию</option>
                            {vacancies.map((vacancy) => <option key={vacancy.id} value={vacancy.id}>{vacancy.name}</option>)}
                        </select>
                    </label>
                    <button type="button" onClick={onGenerate} disabled={loading} className="mt-2 flex w-full items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-indigo-700 disabled:opacity-50">
                        {loading && <span className="h-4 w-4 animate-spin rounded-full border-2 border-indigo-200 border-t-white" aria-hidden="true" />}
                        {loading ? "Генерация…" : "Сгенерировать вопросы"}
                    </button>
                </div>
            )}
        </section>
    );
}

